export const transformUnit = (width: number, height: number) => {
  const outputDpi = 72;
  const mmFactor = (1 / 25.4) * outputDpi;

  const array = [width * mmFactor, height * mmFactor];

  return array;
};
